module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2klEQVQ4T+3SsSoFYBjG8d+T1SR3YLBY2CSLS5DFzmYiShkYSAbJBbgFk1XExgUoWZUrIMurb6BzjpNzitE3/79/7/s8b/zypd//qprAMWYxglusJ3nq5b8JqmoMj3jGCV6xghlMJnnplPQTHGIJU0neGlxVjbvHVZKNQYLLBifZ6gSrag8LSeYHCe5wnuSgR9CEy0mm+wqqahyrWMMDbnoCm2tr4RRnn1l8ZVBVmzgastWdJPuN7RRso2vsH2S7SVom/4K/zqDd+jVGB1T5jsUkF10tDNn/N+wDatxbER+t8bIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/锁.png
// module id = LnVC
// module chunks = 1